import { Grid, Skeleton, Typography } from "@mui/material";
import React from "react";
import TableRowSkeleton from "../../../components/skeletons/TableRowSkeleton";

const TabsSkeleton = () => {
  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <Typography
            color={"#28A745"}
            fontWeight={"bold"}
            padding={"0.5rem"}
            borderRadius={"5px"}
            sx={{
              cursor: "pointer",
              width: "fit-content",
              "&: hover": { color: "#fff", background: "#28A745" },
            }}
          >
            <Skeleton variant="rectangular" width={200} height={30} />
          </Typography>
        </Grid>
        <TableRowSkeleton rowsNum={7} columnsNum={8} width={160} />
      </Grid>
    </>
  );
};

export default TabsSkeleton;
